module.exports = __webpack_public_path__ + "img/attachment.46596fac.png";